import {createModel} from '@rematch/core';

import {fetchMyQuestions} from '~/services/questions';

import type {RootModel} from '.';

export type QuestionsState = any;

export const questions = createModel<RootModel>()({
  state: {
    data: {
      items: [],
      total: 0,
    },
    loading: true,
  },
  reducers: {
    set: (_: QuestionsState, data: any) => ({
      data,
      loading: false,
    }),
  },
  effects: (dispatch) => {
    // eslint-disable-next-line @typescript-eslint/no-shadow
    const {questions} = dispatch;

    return {
      async loadQuestions(): Promise<void> {
        const response = await fetchMyQuestions();

        questions.set(response.data);
      },
    };
  },
});
